import { SessionStorage } from '@app/utils/storage';

export type MenuItemSessionData = {
  amount: number;
  complements: { [groupId: string]: { [complementId: string]: number } };
};

export const MenuItemDetailsSession = {
  setMenuItemFilled(menuItemId: string, data: MenuItemSessionData) {
    SessionStorage.setItem(`menu-item-details-${menuItemId}`, JSON.stringify(data));
  },
  getMenuItemDataPreviouslyFilled(menuItemId: string) {
    const dataAsString = SessionStorage.getItem(`menu-item-details-${menuItemId}`);
    return dataAsString ? (JSON.parse(dataAsString) as MenuItemSessionData) : null;
  },
  removeMenuItemPreviousFilled(menuItemId: string) {
    SessionStorage.removeItem(`menu-item-details-${menuItemId}`);
  },
};
